import { store } from '@sonifi/wb-core/store/store';
import {
  checkRevenueCenter,
  initIrdSettings,
} from '../Settings/services/irdSettings.service';

export async function loaderIrdSettings({ params }) {
  const { groupId, platform } = params;
  const groupIdInt = parseInt(groupId);
  const {
    irdSettings: { revenueCenterSelected },
  } = store.getState();

  await store.dispatch(checkRevenueCenter({ groupId: groupIdInt, revenueCenterSelected }));

  await store.dispatch(
    initIrdSettings({ groupId: groupIdInt, platform }),
  );

  return {};
}
